import gql from 'graphql-tag'
import { listCategories } from './fragments'

export default gql`
query listCategories($filter: CategoryFilterArgs, $params: ListQueryArgs) {
	cashAssist {
		listCategories(filter: $filter, params: $params) {
			...listCategories
		}
	}
}${listCategories}`
